import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { sendFrontAction } from '../services/api'; // Использую единый сервис API
import CarCard from '../components/CarCard';

const Catalog = ({ type }) => {
    const [cars, setCars] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({ body_type: '', sort: '' }); 
    const isUsed = type === 'used';

    // Вынес загрузку в отдельную функцию, чтобы вызывать её при смене типа ИЛИ фильтра
    const loadCars = async () => {
        setLoading(true);
        try {
            // Отправлю на action  'catalog', передавая тип (new/used) и выбранные фильтры кузова
            const data = await sendFrontAction('catalog', { 
                type: type,
                body_type: filters.body_type 
            });
            setCars(data); 
        } catch (error) {
            console.error("Ошибка загрузки каталога автомобилей:", error);
        } finally {
            setLoading(false); // Включения loader в любом случае
        }
    };

    // Срабатывает при изменении вкладки (новые/бу) или при изменении фильтра кузова
    useEffect(() => {
        loadCars();
    }, [type, filters.body_type]);

    // Обработчик изменения фильтра кузова
    const handleFilterChange = (e) => {
        setFilters({ ...filters, body_type: e.target.value });
    };

    if (loading) return <div style={styles.loader}>Загрузка моделей BMW....</div>;

    return (
        <div style={styles.container}>
            <Link to="/" style={styles.backLink}>‹ Назад на главное меню</Link>
            
            <h1 style={styles.mainTitle}>
                {isUsed ? 'BMW с пробегом' : 'Новые BMW в наличии'}
            </h1>

            <div style={styles.filterGrid}>
                <div style={styles.filterBox}>
                    <select style={styles.select} onChange={handleFilterChange} value={filters.body_type}>
                        <option value="">Все типы кузова</option>
                        <option value="Sedan">Седан</option>
                        <option value="SUV">Внедорожник</option>
                        <option value="Coupe">Купе</option>
                    </select>
                </div>
                {["Цена", "Двигатель", "Цвет"].map(cat => (
                    <div key={cat} style={styles.filterBox}>
                        <select style={styles.select}><option>{cat}</option></select>
                    </div>
                ))}
            </div>

            <div style={styles.activeFilterRow}>
                <button style={styles.resetBtn} onClick={() => setFilters({ body_type: '', sort: '' })}>Сбросить фильтры</button>
            </div>

            <div style={styles.grid}>
                {cars && cars.length > 0 ? (
                    cars.map(car => (
                        <CarCard 
                            key={car.id} 
                            car={{
                                ...car,
                                displayPrice: isUsed ? car.price : car.price_base,
                                year: isUsed ? car.year_of_issue : car.year
                            }}
                            isUsed={isUsed} 
                        />
                    ))
                ) : (
                    <p style={styles.noData}>В данный момент нет доступных авто.</p>
                )}
            </div>
        </div>
    );
};

// Добавил недостающий стиль для лоадера, чтобы не ловить ошибку undefined
const styles = {
    container: {
        padding: '120px 8% 50px 8%', 
        backgroundColor: '#fff',
        minHeight: '100vh',
        fontFamily: 'Arial, sans-serif'
    },
    loader: {
        padding: '150px',
        textAlign: 'center',
        fontSize: '24px',
        fontWeight: '300'
    },
    backLink: {
        textDecoration: 'none',
        color: '#000',
        fontWeight: 'bold',
        fontSize: '14px',
        display: 'block',
        marginBottom: '30px'
    },
    mainTitle: {
        fontSize: '42px',
        fontWeight: '300',
        marginBottom: '15px',
        color: '#262626'
    },
    filterGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)', 
        gap: '12px',
        marginBottom: '15px'
    },
    filterBox: {
        border: '1px solid #000',
        padding: '12px 15px',
        display: 'flex',
        alignItems: 'center'
    },
    select: {
        width: '100%',
        border: 'none',
        outline: 'none',
        fontSize: '14px',
        appearance: 'none',
        background: 'transparent',
        cursor: 'pointer'
    },
    activeFilterRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        marginTop: '25px'
    },
    resetBtn: {
        backgroundColor: '#4d4d4d',
        color: '#fff',
        border: 'none',
        padding: '10px 25px',
        fontSize: '13px',
        fontWeight: 'bold',
        cursor: 'pointer'
    },
    noData: {
        fontSize: '16px',
        color: '#999',
        gridColumn: '1 / -1',
        textAlign: 'center',
        padding: '50px'
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)', 
        gap: '40px',
        marginTop: '20px'
    }
};

export default Catalog;